export enum LocalPreferenceType {
  LastVisitedSpaceId = 'last-visited-space-id',
  LastVisitedResourceBySpaceId = 'last-visited-resource-by-space-id',
  LastWorkspaceName = 'last-workspace-name',
  LastVisitedResource = 'last-visited-resource',
  LastVisitedDatabaseId = 'last-visited-database-id',
  LastVisitedCollectionId = 'last-visited-collection-id',
  AttachmentsFilePropertyIds = 'attachments-file-property-ids',
  WorkspaceTabs = 'workspace-tabs',
  FilesSort = 'files-sort',
  DatabaseItemLayoutByViewId = 'database-item-layout-by-view-id',
  DashboardGlobalFilters = 'dashboard-global-filters',
}
